var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckVerified01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5876_69389)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.49935 9.99935L9.16602 11.666L12.916 7.91602M6.11082 3.1816C6.78068 3.12814 7.41661 2.86473 7.92807 2.42887C9.12162 1.41173 10.8771 1.41173 12.0706 2.42887C12.5821 2.86473 13.218 3.12814 13.8879 3.1816C15.4511 3.30634 16.6924 4.54764 16.8171 6.11082C16.8706 6.78068 17.134 7.41661 17.5698 7.92807C18.587 9.12162 18.587 10.8771 17.5698 12.0706C17.134 12.5821 16.8706 13.218 16.8171 13.8879C16.6924 15.4511 15.4511 16.6924 13.8879 16.8171C13.218 16.8706 12.5821 17.134 12.0706 17.5698C10.8771 18.587 9.12162 18.587 7.92807 17.5698C7.41661 17.134 6.78068 16.8706 6.11082 16.8171C4.54764 16.6924 3.30634 15.4511 3.1816 13.8879C3.12814 13.218 2.86473 12.5821 2.42887 12.0706C1.41173 10.8771 1.41173 9.12162 2.42887 7.92807C2.86473 7.41661 3.12814 6.78068 3.1816 6.11082C3.30634 4.54764 4.54764 3.30634 6.11082 3.1816Z",
    stroke: "#039855",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5876_69389"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckVerified01);
export default __webpack_public_path__ + "static/media/check-verified-01.aa0f380cf13923c9c993b9172cc28c3f.svg";
export { ForwardRef as ReactComponent };